// extracted by mini-css-extract-plugin
module.exports = {"excelButton":"styles_excelButton__ie9Kn"};